import { type Control, useFormContext } from 'react-hook-form'
import { Dropdown } from '~/components/Form'
import { useConfig } from '~/domains/configuration/queries/config'
import { QualificationsDropdown } from '~/domains/taxonomies/components/QualificationsDropdown'
import { useTaxonomy } from '~/domains/taxonomies/queries/useTaxonomy'

type ApplicantIntegrationFieldsValues = {
  qualifications: string[]
  segmentations: string[]
}

export const ApplicantIntegrationFields = () => {
  const {
    register,
    control: typedControl,
    setValue,
    watch
  } = useFormContext<ApplicantIntegrationFieldsValues>()
  const control = typedControl as Control<any>
  const sharedProps = { register, control, setValue, watch }

  const { data: mandatoryQualification = true } = useConfig(
    'mandatory_applicant.qualification'
  )
  const { data: segmentations } = useTaxonomy('segmentations')

  return (
    <>
      <QualificationsDropdown
        label="Qualifications"
        multiple
        name="qualifications"
        required={mandatoryQualification}
        {...sharedProps}
      />
      <Dropdown
        label="Segmentations"
        multiple
        searchable
        name="segmentations"
        {...sharedProps}
        options={
          segmentations?.map((segmentation: any) => ({
            label: segmentation.name,
            value: String(segmentation.id)
          })) || []
        }
      />
    </>
  )
}
